import { Button, CircularProgress, Container, Dialog, Fab, Grid, makeStyles, Snackbar, TextField, Tooltip, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add';
import React, { useState } from 'react'
import NotSureDialog from './NotSureDialog';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { addOwnWord, addWODKnownWord, addWordPacketToKnownWords, addWordToLearn, getWordPacket, skipWordFromWordPacket } from '../../actions';
import Alert from '@material-ui/lab/Alert';


const useStyles = makeStyles((theme) => ({

    sectionTitle: {
        margin: "10px"
    },
    orText: {
        overflow: "hidden",
        textAlign: "center",
        marginTop: "100px",
        marginBottom: "100px",
        '&:after': {
            backgroundColor: "#c9c8c5",
            content: '""',
            display: "inline-block",
            height: "1px",
            position: "relative",
            verticalAlign: "middle",
            width: '35%'
        },
        '&:before': {
            backgroundColor: "#c9c8c5",
            content: '""',
            display: "inline-block",
            height: "1px",
            position: "relative",
            verticalAlign: "middle",
            width: '35%'
        }
    },
    nonRoundButtons: {
        [theme.breakpoints.up('sm')]: {
            margin: '5px'
        },
        margin: "25px 5px"

    },
    fabButton: {
        [theme.breakpoints.up('md')]: {
            width: "70px",
            height: "70px",
        },
        margin: "8px",
        background: '#53f048'
    },
    gridSpacingForButtons: {
        padding: "10px"
    },
    box: {
        border: "3px solid #c4c4c4",
        marginTop: "25px",
        padding: "20px 10px",
        marginBottom: "25px",
        textAlign: "center"
    }, word: {
        [theme.breakpoints.up('sm')]: {
        margin: "50px 0px",
        padding: "20px 0px",
        color: "#7f8"
        },
        margin: "20px 0px 0px",
        padding: "20px 0px",
        color: "#7f8"
    }, spinner: {
        margin: "40px 0px",
    }, textField: {
        margin: "40px 10px",
        flexGrow: 1,
    }, closeRow: {
        margin: "20px 0px"
    }

}));








const AddWordDialog = ({ closeFunction, openSnackBarInDashBoard }) => {
    const theme = useTheme();
    const classes = useStyles();
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("md"));
    const wordPacket = useSelector(state => state.wordPacket.wordsPacket);
    const wordOfTheDay = useSelector(state => state.wordPacket.wordOfTheDay)
    const [currWordDisplayed, changeCurrWordDisplayed] = useState(null);
    const [isNotSureDialogOpen, setNotSureDialogOpen] = useState(false);
    const dispatch = useDispatch();
    const [snackBarOpen, snackBarToggle] = useState(false);
    const [snackBarSeverityAndMessage, setSnackBarSeverityAndMessage] = useState({ message: '', severity: '' });
    const [ShouldShowAddOwnErrorAlert, setShouldShowAddOwnErrorAlert] = useState(false);
    const [addOwnErrorInfo, setAddOwnErrorInfo] = useState({ errorMessage: '', errorSeverity: '' })
    const [addOwnWordValue, setAddOwnWordValue] = useState("");




    // $            Opening and closing the Not Sure Dialog
    const handleNotSureDialogOpenWordOfTheDay = () => {

        changeCurrWordDisplayed(wordOfTheDay);
        setNotSureDialogOpen(true);

    }

    const handleNotSureDialogOpenWordsArray = () => {
        if (!wordPacket[0]) {

        } else {
            changeCurrWordDisplayed(wordPacket[0]);
            setNotSureDialogOpen(true);
        }
    }

    const handleNotSureDialogClose = () => {
        setNotSureDialogOpen(false);
    }

    //%                 The SnackBar methods                        

    const handleClose = () => {
        snackBarToggle(false);
    }

    const createSnackBarCode = () => {
        return (
            <Snackbar open={snackBarOpen} anchorOrigin={{ horizontal: 'center', vertical: 'top' }} autoHideDuration={4000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={snackBarSeverityAndMessage.severity} >
                    {snackBarSeverityAndMessage.message}
                </Alert>
            </Snackbar>
        )
    }



    //$                             Managing Known words                                        
    const addWordOfDayToKnownWords = async (word) => {
        try {
            await dispatch(addWODKnownWord(word));
            setSnackBarSeverityAndMessage({ message: "Word added to list of known Words. You won't see it again.", severity: 'success' });
            snackBarToggle(true);

        } catch (err) {
            if (err.response.data.message) {
                setSnackBarSeverityAndMessage({ message: err.response.data.message, severity: 'error' });
                snackBarToggle(true);
            }
        }
    }
    const skipWordWordPacket = async () => {
        let shouldFetchWordPacket = false;
        if (wordPacket.length <= 1) shouldFetchWordPacket = true;
        dispatch(skipWordFromWordPacket())
        try {
            if (shouldFetchWordPacket) {
                await dispatch(getWordPacket())
            }
        } catch (error) {
            if (error.response) {
                if (error.response.data) {
                    if (error.response.data.message) {
                        openSnackBarInDashBoard();
                        closeFunction();
                        snackBarToggle(true);
                    }
                }
            }
        }
    }



    const addWordFromPacketToKnownWords = async (word) => {
        let shouldFetchWordPacket = false;
        try {
            if (wordPacket.length <= 1) {
                shouldFetchWordPacket = true;
            }
            await dispatch(addWordPacketToKnownWords(word.wordId));
            setSnackBarSeverityAndMessage({ message: "Word added to list of known Words. You won't see it again.", severity: 'success' });
            snackBarToggle(true);

        } catch (error) {
            console.log(error.response);
        }
        try {
            if (shouldFetchWordPacket) {
                await dispatch(getWordPacket())
            }
        } catch (error) {
            if (error.response) {
                if (error.response.data) {
                    if (error.response.data.message) {
                        openSnackBarInDashBoard();
                        closeFunction();
                        snackBarToggle(true);
                    }
                }
            }
        }


    }
    //%         This is to manage the errors for add your own word and managing the dispatch event
    const addYourOwnWordClick = async () => {
        try {

            await dispatch(addOwnWord(addOwnWordValue));
            closeFunction();
            openSnackBarInDashBoard("Word added Successfully.", 'success');
        } catch (err) {
            if (err.response.data.errorMessage && err.response.data.errorSeverity) {
                setAddOwnErrorInfo(err.response.data);
                setShouldShowAddOwnErrorAlert(true);
            }

        }

    }




    const shouldRenderLoaderForWordOfTheDay = () => {

        return (wordOfTheDay.word === '') ? <CircularProgress className={classes.spinner} />
            :
            <Typography className={classes.word} > {wordOfTheDay.word} </Typography>;
    }

    return (
        <React.Fragment>
            {createSnackBarCode()}
            <Container>

                <Grid className={classes.closeRow} container justify="flex-end">
                    <Grid item>
                        <Button onClick={() => closeFunction()} variant="outlined">
                            <CloseIcon />
                        </Button>
                    </Grid>
                </Grid>

                {(wordOfTheDay === null) ?

                    <Container className={classes.box}>
                        <Typography variant="h6" className={classes.word}>
                            Word of The Day in your bank.
                        </Typography>
                    </Container>
                    :
                    <Container className={classes.box}>
                        <Typography variant="h6" className={classes.sectionTitle}> Word of the day </Typography>

                        {wordOfTheDay && shouldRenderLoaderForWordOfTheDay()}

                        <Grid container justify="center" alignItems="center" className={classes.gridSpacingForButtons}>
                            <Grid item xs={12} sm={5}>
                                <Tooltip enterDelay={500} enterNextDelay={300} title="You won't see this word again. This can be undone in your portfolio.">
                                    <span>
                                        <Button onClick={() => addWordOfDayToKnownWords(wordOfTheDay.wordId)} disabled={!wordOfTheDay || wordOfTheDay.word === ''} size='large' className={classes.nonRoundButtons} variant="contained" color="secondary"><Typography variant={isMdOrUp ? "button" : "caption"}>Know it</Typography></Button>
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Tooltip enterDelay={500} enterNextDelay={300} title="Choose to learn this word.">
                                    <span>
                                        <Fab disabled={!wordOfTheDay || wordOfTheDay.word === ''} className={classes.fabButton} onClick={() => { dispatch(addWordToLearn(wordOfTheDay.wordId)); closeFunction(); openSnackBarInDashBoard("Word added Successfully.", 'success') }}>
                                            <AddIcon />
                                        </Fab>
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <Tooltip enterDelay={500} enterNextDelay={300} title="Test to see if you know it.">
                                    <span>
                                        <Button disabled={!wordOfTheDay || wordOfTheDay.word === ''} onClick={handleNotSureDialogOpenWordOfTheDay} size='large' className={classes.nonRoundButtons} variant="contained" color="primary"><Typography>Not Sure</Typography></Button>
                                    </span>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Container>
                }



                <Typography variant={isMdOrUp ? "h6" : "subtitle2"} className={classes.orText}> OR </Typography>




                <Container className={classes.box}>
                    <Typography className={classes.sectionTitle}>Get word from the Market</Typography>


                    {(wordPacket.length < 1) ?

                        <CircularProgress className={classes.spinner} />
                        :
                        <Typography variant="h6" className={classes.word} > {wordPacket[0].word} </Typography>
                    }
                    <Grid container justify="center" alignItems="center">
                        <Tooltip enterDelay={500} enterNextDelay={300} title="This is a word for future You.">
                            <span>
                                <Button className={classes.nonRoundButtons} onClick={skipWordWordPacket} disabled={wordPacket.length < 1} variant="outlined" size='large'>
                                    Skip
                                </Button>
                            </span>
                        </Tooltip>
                    </Grid>


                    <Grid container justify="center" alignItems="center" className={classes.gridSpacingForButtons}>
                        <Grid item xs={12} sm={5}>
                            <Tooltip enterDelay={500} enterNextDelay={300} title="You won't see this word again. This can be undone in your portfolio.">
                                <span>
                                    <Button onClick={() => addWordFromPacketToKnownWords(wordPacket[0])} disabled={wordPacket.length < 1} size='large' className={classes.nonRoundButtons} color="secondary" variant="contained"><Typography variant={isMdOrUp ? "button" : "caption"}>Know it</Typography></Button>
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Tooltip enterDelay={500} enterNextDelay={300} title="Choose to learn this word.">
                                <span>
                                    <Fab disabled={wordPacket.length < 1} className={classes.fabButton} onClick={() => { dispatch(addWordToLearn(wordPacket[0].wordId)); closeFunction(); openSnackBarInDashBoard("Word added Successfully.", 'success'); }} >
                                        <AddIcon />
                                    </Fab>
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12} sm={5}>

                            <Tooltip enterDelay={500} enterNextDelay={300} title="Test to see if you know it.">
                                <span>
                                    <Button disabled={wordPacket.length < 1} size='large' onClick={handleNotSureDialogOpenWordsArray} className={classes.nonRoundButtons} color="primary" variant="contained"><Typography>Not Sure</Typography></Button>

                                </span>
                            </Tooltip>

                        </Grid>
                    </Grid>
                </Container>










                <Typography variant={isMdOrUp ? "h6" : "subtitle2"} className={classes.orText}> OR </Typography>





                <Container className={classes.box}>
                    <Typography variant="h6" className={classes.sectionTitle}>Add your own Word </Typography>


                    <Grid container justify="center" alignItems="center">



                        <TextField value={addOwnWordValue} onChange={(e) => { setAddOwnWordValue(e.target.value); setShouldShowAddOwnErrorAlert(false); }} size={isMdOrUp ? "medium" : "small"} label="Your Word" variant="outlined" className={classes.textField} ></TextField>


                        <Tooltip enterDelay={500} enterNextDelay={300} title="Add to Investments">
                            <span>
                                <Fab onClick={() => addYourOwnWordClick()} className={classes.fabButton}>
                                    <AddIcon />
                                </Fab>
                            </span>
                        </Tooltip>




                    </Grid>
                    <Grid container justify="center" alignItems="center">

                        {ShouldShowAddOwnErrorAlert ? <Alert severity={addOwnErrorInfo.errorSeverity} > {addOwnErrorInfo.errorMessage} </Alert> : null}
                    </Grid>


                </Container>



            </Container>


            <Dialog maxWidth="xs" open={isNotSureDialogOpen} onClose={handleNotSureDialogClose} scroll='body' >
                <NotSureDialog handleDialogClose={handleNotSureDialogClose} wordToDisplay={currWordDisplayed} />
            </Dialog>
        </React.Fragment>
    )
}



export default AddWordDialog
